/* Surcharges des skins liées à l'affichage RTL */
import {IReg, REG} from "lib/commons/registry";

export function ovrReg(reg: IReg<any>) {
	/** FIXME : à supprimer qd utilisation de inset-inline-start/inset-inline-end */
	reg.overlaySkin("box-ptritem", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  wed-diff-mark {
		  left: unset;
		  right: -5px;
	  }
	`);

	/** FIXME : à supprimer qd utilisation de inset-inline-start/inset-inline-end */
	reg.overlaySkin("wsp-src-tab", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  #close {
		  left: 0;
		  right: unset;
	  }
	`);

	reg.overlaySkin("itemMain/c-tabs", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  :host(.pinned) > div {
		  background-position: left;
	  }

	  c-tab {
		  border-radius: 0 5px 5px 0;
	  }

	  c-tab.selected {
		  background: linear-gradient(to right, var(--tabf-bgcolor), var(--tabf-off-bgcolor));
	  }
	`);

	reg.overlaySkin("wsp-list/cellInList", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  .wsp.public {
		  background: url('/@skin@/wsp/objects/lockOpen.svg') no-repeat top left/.7em, url('/@skin@/wsp/objects/wsp/wsp.svg') no-repeat center/contain;
	  }

	  .drf.public {
		  background: url('/@skin@/wsp/objects/lockOpen.svg') no-repeat top left/.7em, url('/@skin@/wsp/objects/wsp/wspDrf.svg') no-repeat center/contain;
	  }

	  .drv.public {
		  background: url('/@skin@/wsp/objects/lockOpen.svg') no-repeat top left/.7em, url('/@skin@/wsp/objects/wsp/wspDrv.svg') no-repeat center/contain;
	  }
	`);

	reg.overlaySkin("wsp-bookmarks/grid", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  .current {
		  background-position: left;
	  }
	`);

	reg.overlaySkin("wsp-space-tree/grid", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  .current {
		  background-position: left;
	  }
	`);

	reg.overlaySkin("wsp-src-grid", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  .current {
		  background-position: left;
	  }
	`);

	reg.overlaySkin("wsp-finddoc", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  #search {
		  background-position: right;
	  }
	`);

	reg.overlaySkin("wsps-list-wspsmgr", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  #search {
		  background-position: right;
	  }
	`);

	reg.overlaySkin("wsp-space-tree", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  #search {
		  background-position: right;
	  }
	`);

	reg.overlaySkin("wsp-list", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  #search {
		background-position: right;
	}
	`);

	reg.overlaySkin("wed-diff-histoitem", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  #frontArrowEnd {
		transform: scaleX(-1);
	}
	`);

	reg.overlaySkin("wsp-fastfind-item", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  input {
		  background-position: right;
	  }
	`);

	reg.overlaySkin("wsp-toc", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  wsp-toc-twisty[state=closed] {
		  background-image: url(/@skin@/wsp/views/toc/closed-rtl.svg);
	  }
	`);

}


